export const tsToDateStr = (ts) =>
  new Date(ts * 1000).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

export const tsToDateInput = (ts) => new Date(ts * 1000).toISOString().slice(0, 10);
export const dateInputToTs = (val) => Math.floor(new Date(val).getTime() / 1000);

export const tsToLabel = (ts, y) => {
  const n = Number(ts);
  if (!Number.isFinite(n)) return 'Date invalide';

  const date = new Date(n * 1000).toLocaleString('fr-FR', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });

  return y != null ? `${date} — ${Math.round(y * 10) / 10} dB` : date;
};

export const parseSensorPositionFormula = (formula) => {
  const [sensorId, position] = formula
    .split(';')[0]
    .match(/\d+/g)
    .map(Number);
  return { sensorId, position };
};

export const sensorPositionFormulaToLabel = (formula) => {
  const { sensorId, position } = parseSensorPositionFormula(formula);
  return `Capteur ${sensorId} - Position ${position}`;
};

export const findDataBySensorAndPosition = (data, sensorId, position) => {
  if (!sensorId || position === undefined) return null;
  const sid = Number(sensorId);
  const pos = Number(position);
  return (
    data.find(
      (d) => Number(d.id_sensor) === sid && Number(d.position_in_sensor) === pos
    ) ?? null
  );
};

// Correspondance par index d'abord (graphCurves[i] ↔ donnees[i]), puis par id/position.
export const findDataForFormula = (data, sensorsPositions, formula) => {
  if (!formula || !data?.length) return null;
  const idx = (sensorsPositions || []).findIndex((sp) => sp.formula === formula);
  if (idx >= 0 && data[idx]) return data[idx];
  try {
    const { sensorId, position } = parseSensorPositionFormula(formula);
    return findDataBySensorAndPosition(data, sensorId, position);
  } catch {
    return null;
  }
};
